import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import Sesion from './componentes/Sesion'
import { aplicarTamano, leerTamano } from './lib/rejilla'
import { iniciarTema } from './lib/tema'
import './estilos.css'

// Antes de pintar nada, o las portadas darian un salto de tamano al arrancar
aplicarTamano(leerTamano())
// Igual con el tema: puesto despues, la app arrancaria un instante en Tinta
iniciarTema()

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Las fuentes externas son lentas y a veces se caen: no conviene
      // reintentar en bucle ni refrescar al volver a la pestana.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      // Sin esto la mitad de la app no existe sin conexion: por defecto
      // React Query deja las consultas *pausadas* mientras el navegador se
      // declara sin red, y la funcion no llega a ejecutarse nunca. Aqui
      // varias consultas solo leen de IndexedDB (las descargas del movil) y
      // las que si van al servidor ya caen a los datos locales por su
      // cuenta, asi que pausarlas solo servia para dejar Descargas en blanco
      // y para que el lector no encontrara los capitulos guardados.
      networkMode: 'always',
    },
    mutations: {
      // Igual que arriba: borrar una descarga es cosa del telefono.
      networkMode: 'always',
    },
  },
})

// El service worker permite abrir la app sin conexion y sirve las paginas
// ya vistas desde el cache. Solo funciona bajo HTTPS, que es justo lo que
// se monto en el VPS.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <Sesion>
          <App />
        </Sesion>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
